<template>
  <div class="modal drivers-edit">
    <div class="modal__wrapper">
      <div class="modal__close" @click="$emit('close-modal')">
        <fa-icon icon="times"></fa-icon>
      </div>
      <div class="modal__title">Voertuig wijzigen</div>
      <div class="modal__body">
        <div class="form">
          <div>
            <div class="form__field">
              <label>Merk</label>
              <input type="text" class="input" v-model="copyItem.MERK">
            </div>
            <div class="form__field">
              <label>Model</label>
              <input type="text" class="input" v-model="copyItem.MODEL">
            </div>
            <div class="form__field">
              <label>Plaatsen</label>
              <input type="number" class="input input--number" v-model="copyItem.PLAATSEN">
            </div>
            <div class="form__field">
              <label>Nummerplaat</label>
              <input type="text" class="input" v-model="copyItem.PLAAT">
            </div>
          </div>
          <div>
            <div class="form__field">
              <label>Vergunning</label>
              <input type="text" class="input" v-model="copyItem.VERGUNNING">
            </div>
            <div class="form__field">
              <label>Datum inschrijving</label>
              <DatePicker v-model="copyItem.DATUMINSCHRIJVING" type="date" format="DD/MM/YYYY"
                          value-type="DD/MM/YYYY"></DatePicker>
            </div>
            <div class="form__field">
              <label>Verzekerd tot</label>
              <DatePicker v-model="copyItem.VERVALDAGVERZEKERING" type="date" format="DD/MM/YYYY"
                          value-type="DD/MM/YYYY"></DatePicker>
            </div>
            <div class="form__field">
              <label>Gekeurd tot</label>
              <DatePicker v-model="copyItem.VERVALDAGKEURING" type="date" format="DD/MM/YYYY"
                          value-type="DD/MM/YYYY"></DatePicker>
            </div>
          </div>
        </div>
        <div class="modal__subtitle">Uploads</div>
        <div class="upload-assets">
          <div class="form__field">
            <label>Foto</label><input type="file" accept="image/*" id="FOTO" name="FOTO" class="file-input" @change="srcChanged($event,'foto')">
            <div class="file-preview file-preview--image" v-if="fotoSource" @click="$emit('preview-click',fotoSource)">
              <img :src="fotoSource" alt="foto voertuig">
            </div>
          </div>
          <div class="form__field">
            <label>Keuring</label>
            <input type="file" accept="image/*" class="file-input" id="KEURING" name="KEURING" @change="srcChanged($event,'keuring')">
            <div class="file-preview file-preview--image" v-if="keuringSource" @click="$emit('preview-click',keuringSource)">
              <img :src="keuringSource" alt="foto keuringsbewijs">
            </div>
          </div>
          <div class="form__field">
            <label>Verzekering</label>
            <input type="file" accept="image/*" class="file-input" id="VERZEKERING" name="VERZEKERING" @change="srcChanged($event,'verzekering')">
            <div class="file-preview file-preview--image" v-if="verzekeringSource" @click="$emit('preview-click',verzekeringSource)">
              <img :src="verzekeringSource" alt="foto verzekering">
            </div>
          </div>
          <div class="form__field">
            <label>Vergunning</label>
            <input type="file" accept="image/*" class="file-input" id="DOCVERGUNNING" name="DOCVERGUNNING" @change="srcChanged($event,'docvergunning')">
            <div class="file-preview file-preview--image" v-if="docvergunningSource" @click="$emit('preview-click',docvergunningSource)">
              <img :src="docvergunningSource" alt="foto vergunning">
            </div>
          </div>
        </div>
      </div>
      <div class="modal__controls">
        <button class="button button--cancel" @click="$emit('close-modal')">Annuleer</button>
        <button class="button button--accept" @click="saveClicked">Opslaan</button>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import SubcontractorService from "@/services/subcontractor";
import {ObjectMixin} from "@/mixins/ObjectMixin";

export default {
  name: "FleetEdit",

  components: {
    DatePicker
  },

  props: {
    item: {required: true},
    fileRoot: {}
  },

  data() {
    return {
      fotoSource: null,
      keuringSource: null,
      verzekeringSource: null,
      docvergunningSource: null,
      copyItem: JSON.parse(JSON.stringify(this.item))
    }
  },
  created(){
    this.fotoSource = this.copyItem.FOTO?`${this.fileRoot}${this.copyItem.FOTO}`:"";
    this.keuringSource = this.copyItem.KEURING?`${this.fileRoot}${this.copyItem.KEURING}`:"";
    this.verzekeringSource = this.copyItem.VERZEKERING?`${this.fileRoot}${this.copyItem.VERZEKERING}`:"";
    this.docvergunningSource = this.copyItem.DOCVERGUNNING?`${this.fileRoot}${this.copyItem.DOCVERGUNNING}`:"";
  },

  methods:{
    srcChanged(input,target){
      if(input.target.files && input.target.files[0]){
        this.copyItem[target.toUpperCase()] = input.target.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
          this[`${target}Source`] = e.target.result;
        }

        reader.readAsDataURL(input.target.files[0]);
      }
    },
    saveClicked(){
      const data = {...this.copyItem};
      if(data.DATUMINSCHRIJVING){
        data.DATUMINSCHRIJVING = ObjectMixin.formatDateSql(data.DATUMINSCHRIJVING);
      }
      if(data.VERVALDAGVERZEKERING){
        data.VERVALDAGVERZEKERING = ObjectMixin.formatDateSql(data.VERVALDAGVERZEKERING);
      }
      if(data.VERVALDAGKEURING){
        data.VERVALDAGKEURING = ObjectMixin.formatDateSql(data.VERVALDAGKEURING);
      }
      SubcontractorService.editVehicle(data).then(res => {
        if(res){
          this.$emit('data-edit');
        }
      });
    }
  }
}
</script>
